/* The Sample Service selector. Markup and data: snippets/sample-service.liquid.

   The Liquid emits one row per published Eau de Parfum SKU, in best-selling
   order. This file folds those rows into one entry per fragrance and builds
   the sets from them, so nothing here is a list anyone maintains:

     Most loved   first three fragrances by rank
     Most recent  newest three by EARLIEST publish date across a fragrance's SKUs
     <family>     first three by rank within custom.fragrance_family
     Inspire me   three at random; also offered inside any empty card

   What reaches the order: "Sample 1/2/3" (unchanged, fulfilment reads these)
   and "Set" (how the three were chosen, e.g. "Fern" or "Own choice"; shown
   in the basket and on the order, and the field to report on). */

(function () {
  'use strict';

  // Inspire me reveal: each card fades in from nothing, one after another.
  // It replaced the fruit-machine reel (Thom, 29 Sep 2026: "tacky").
  // Slow and spaced (Thom, 29 Sep 2026: "not mental, but luxury").
  // Card 1 answers the click at once (Thom: "click and something starts").
  var REVEAL_FIRST = 30, REVEAL_GAP = 900;         // ms: card 1 on the next frames, then +0.9s each
  var STORE_KEY = 'phss_started'; // a flag only: no email is kept in the browser

  function init(root) {
    var cfg = JSON.parse(root.querySelector('[data-ph-ss-config]').textContent);
    var rows = JSON.parse(root.querySelector('[data-ph-ss-rows]').textContent);
    var lib = fold(rows);
    var health = JSON.parse((root.querySelector('[data-ph-ss-health]') || {}).textContent || '{}');
    if (health.truncated) console.error('[Sample Service] source collection "' + health.source + '" has more than 250 SKUs: the list is cut off. Raise it with the developer.');
    if (lib.length < 3 || health.truncated) {
      console.error('[Sample Service] only ' + lib.length + ' fragrances from "' + health.source + '". Is the collection renamed or empty?');
      root.querySelector('[data-ph-ss-gate]').hidden = true;
      root.querySelector('[data-ph-ss-down]').hidden = false;
      return;
    }
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var byName = {};
    lib.forEach(function (x) { byName[x.name] = x; });
    var families = unique(lib.map(function (x) { return x.fam; }).filter(Boolean)).sort(az);
    var sets = [
      { key: 'Most loved', names: lib.slice(0, 3).map(nameOf) },
      { key: 'Most recent', names: lib.slice().sort(function (a, b) { return b.first - a.first; }).slice(0, 3).map(nameOf) }
    ].concat(families.map(function (f) {
      return { key: f, names: lib.filter(function (x) { return x.fam === f; }).slice(0, 3).map(nameOf) };
    })).filter(function (s) { return s.names.length === 3; });
    sets.push({ key: 'Inspire me', names: null }); // was 'Surprise me' until 29 Sep 2026 (Thom)

    var chosen = [null, null, null], setKey = null, setNames = null, filter = 'all';
    var surprised = {};

    $$('[data-ph-ss-count]').forEach(function (el) { el.textContent = lib.length; });

    /* ------------------------------------------------------------ the gate */
    var gate = $('[data-ph-ss-gate]'), picker = $('[data-ph-ss-picker]');
    var emailInput = root.querySelector('.ph-ss__input');
    var remembered = recall();
    if (cfg.customerEmail && !remembered) emailInput.value = cfg.customerEmail;
    if (remembered) openPicker();

    // The consent box and the button say, in words, whether the tick is done.
    var consentBox = $('[data-ph-ss-consent]');
    function syncConsent() {
      var on = consentBox.checked;
      $('[data-ph-ss-consent-box]').classList.toggle('is-done', on);
      $('[data-ph-ss-consent-note]').textContent = on ? 'Thank you. You can continue.' : 'Required to continue. Your voucher is sent by email.';
      $('[data-ph-ss-open]').textContent = on ? 'continue' : 'tick the box above to continue';
    }
    consentBox.addEventListener('change', syncConsent);
    syncConsent();

    $('[data-ph-ss-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        $('[data-ph-ss-err]').hidden = false;
        emailInput.focus();
        return;
      }
      $('[data-ph-ss-err]').hidden = true;
      var consent = $('[data-ph-ss-consent]');
      if (!consent.checked) {
        var box = $('[data-ph-ss-consent-box]');
        box.classList.remove('is-nudge'); void box.offsetWidth; box.classList.add('is-nudge');
        consent.focus();
        return;
      }
      remember('1');
      klaviyoStart(cfg.klaviyo, email);
      openPicker(true);
    });

    function openPicker(fromGate) {
      gate.hidden = true;
      picker.hidden = false;
      // Warm the tray images, and measure every packshot now so frame() has the scale before a card shows.
      lib.forEach(function (x) { var im = new Image(); im.onload = function () { if (fills[x.img] == null) fills[x.img] = measure(im); }; im.src = x.img; });
      if (fromGate) bringIntoView(picker);
    }

    /* After the gate closes, the page is shorter and the tabs can sit above the
       top of the screen (on phones especially). Scroll so they are fully in
       view, clear of the sticky header, with a little room above (Thom,
       28 Sep 2026). Only moves if the tabs are not already comfortably visible. */
    function bringIntoView(node) {
      // The header slides back in as the page scrolls up, so always leave its
      // full height clear. The theme publishes that height as --header-height
      // (67px on phones); the wrapper element itself measures 0.
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 70;
      var offset = headerH + 20;
      var top = node.getBoundingClientRect().top;
      if (top >= offset && top < window.innerHeight * 0.5) return;
      var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: window.pageYOffset + top - offset, behavior: smooth ? 'smooth' : 'auto' });
    }

    /* ---------------------------------------------------------------- tabs */
    function setMode(m) {
      $$('[data-ph-ss-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-ph-ss-pane') !== m; });
      $$('.ph-ss__mode').forEach(function (b) {
        var on = b.getAttribute('data-ph-ss-mode') === m;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on);
      });
    }
    $$('[data-ph-ss-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-ph-ss-mode')); });
    });

    /* ---------------------------------------------------------------- sets */
    function renderSets() {
      var box = $('[data-ph-ss-sets]');
      box.innerHTML = '';
      sets.forEach(function (s) {
        var b = el('button', 'ph-ss__set' + (s.names ? '' : ' ph-ss__set--surprise') + (setKey === s.key ? ' is-on' : ''));
        b.type = 'button';
        b.setAttribute('data-key', 'set:' + s.key);
        b.appendChild(el('span', 'ph-ss__sc', s.key)); // small caps, not Lutz (Thom, 2 Oct 2026)
        b.appendChild(el('span', 'ph-ss__set-names', s.names ? s.names.join(', ') : 'Three chosen at random'));
        b.addEventListener('click', function () { applySet(s); });
        box.appendChild(b);
      });
    }
    function applySet(s) {
      surprised = {};
      var names = s.names ? s.names.slice() : randomNames(3, []);
      chosen = names.slice(); setKey = s.key; setNames = names.slice();
      update();
      reveal([0, 1, 2]); // every set, not only Inspire me (Thom, 29 Sep 2026)
    }

    /* ------------------------------------------------------------- library */
    function renderChips() {
      var box = $('[data-ph-ss-chips]');
      box.innerHTML = '';
      ['all'].concat(families).forEach(function (f) {
        var c = el('button', 'btn btn--primary btn--outline btn--small' + (filter === f ? ' is-on' : ''), f);
        c.type = 'button';
        c.setAttribute('data-key', 'chip:' + f);
        c.setAttribute('role', 'tab');
        c.setAttribute('aria-selected', filter === f);
        c.addEventListener('click', function () { filter = f; renderChips(); renderList(); });
        box.appendChild(c);
      });
    }
    function renderList() {
      var box = $('[data-ph-ss-list]');
      box.innerHTML = '';
      // New (tag _badge_new) first, newest first; then everything A to Z.
      lib.slice().sort(function (a, b) {
        if (a.isNew !== b.isNew) return a.isNew ? -1 : 1;
        if (a.isNew) return b.first - a.first;
        return az(a.name, b.name);
      })
        .filter(function (x) { return filter === 'all' || x.fam === filter; })
        .forEach(function (x) {
          var i = chosen.indexOf(x.name);
          var r = el('button', 'ph-ss__row');
          r.type = 'button';
          r.setAttribute('data-key', 'row:' + x.name);
          r.setAttribute('aria-pressed', i > -1);
          r.appendChild(el('span', 'ph-count' + (i > -1 ? ' is-on' : ''), i > -1 ? String(i + 1) : ''));
          var im = el('img', 'ph-ss__thumb');
          im.src = x.img; im.alt = ''; im.loading = 'lazy'; im.width = 76; im.height = 76;
          r.appendChild(im);
          var t = el('span');
          var nm = el('span', 'ph-ss__display', x.name);
          if (x.isNew) nm.appendChild(el('span', 'ph-ss__new', 'new'));
          t.appendChild(nm);
          if (x.blurb) t.appendChild(el('span', 'ph-ss__blurb', x.blurb));
          if (x.notes) t.appendChild(el('span', 'ph-ss__notes', x.notes));
          r.appendChild(t);
          r.appendChild(el('span', 'ph-ss__row-fam', x.fam || ''));
          r.addEventListener('click', function () { toggle(x.name); });
          box.appendChild(r);
        });
    }
    function toggle(name) {
      var i = chosen.indexOf(name);
      if (i > -1) { chosen[i] = null; update(); return; }
      var e = chosen.indexOf(null);
      if (e === -1) return; // full: remove one first (the × on its card)
      chosen[e] = name;
      update();
      reveal([e]); // a single pick from the library arrives the same way
    }

    /* ---------------------------------------------------------------- tray */
    function renderTray() {
      var box = $('[data-ph-ss-slots]');
      box.innerHTML = '';
      chosen.forEach(function (c, i) {
        var card = el('div', 'ph-ss__pick' + (c ? ' is-filled' : ''));
        card.appendChild(el('span', 'ph-count' + (c ? ' is-on' : ''), String(i + 1)));
        if (!c) {
          var empty = el('span', 'ph-ss__empty', 'choose a perfume or ');
          var rnd = el('button', 'ph-ss__rnd', 'click to inspire me');
          rnd.type = 'button';
          rnd.setAttribute('data-key', 'rnd:' + i);
          rnd.addEventListener('click', function () { fillRandom(i); });
          empty.appendChild(rnd);
          card.appendChild(empty);
        } else {
          var x = byName[c];
          var t = el('span', 'ph-ss__pick-text');
          t.appendChild(el('span', 'ph-ss__display', c));
          if (x.fam) t.appendChild(el('span', 'ph-ss__family', x.fam));
          card.appendChild(t);
          var im = el('img', 'ph-ss__pick-img'); im.alt = ''; frame(im, x.img);
          card.appendChild(im);
          var xb = el('button', 'ph-ss__x', '×');
          xb.type = 'button';
          xb.setAttribute('data-key', 'x:' + i);
          xb.setAttribute('aria-label', 'Remove ' + c);
          xb.addEventListener('click', function () { chosen[i] = null; update(); });
          card.appendChild(xb);
        }
        box.appendChild(card);
      });
      fitNames();

      var n = chosen.filter(Boolean).length;
      $('[data-ph-ss-clear]').disabled = n === 0;
      var pill = $('[data-ph-ss-pill]');
      pill.hidden = !setKey || !n;
      var lbl = label();
      pill.textContent = /edited|inspired$/.test(lbl) || setKey === 'Inspire me' ? lbl : lbl + ' set';
      var add = $('[data-ph-ss-add]');
      add.disabled = n < 3;
      $('[data-ph-ss-add-l1]').textContent = n < 3
        ? (n === 0 ? 'choose three perfumes' : 'choose ' + (3 - n) + ' more')
        : 'add to basket · ' + cfg.price;
    }

    function fillRandom(i) {
      var n = randomNames(1, chosen)[0];
      chosen[i] = n; surprised[n] = true;
      update();
      reveal([i]);
    }

    /* A name is always one line: it shrinks until it fits the card. */
    function fitNames() {
      var narrow = $('[data-ph-ss-slots]').clientWidth <= 560;
      $$('.ph-ss__pick .ph-ss__display').forEach(function (n) { fit(n, narrow ? 16 : 20); });
    }
    function fit(node, size) {
      node.style.fontSize = size + 'px';
      while (node.scrollWidth > node.clientWidth + 1 && size > 10) {
        size -= 1; node.style.fontSize = size + 'px';
      }
    }

    function label() {
      var extra = chosen.filter(function (c) { return c && surprised[c]; }).length;
      var tail = extra ? ' + ' + extra + ' inspired' : '';
      if (!setKey) return 'Own choice' + tail;
      var same = setNames && chosen.every(Boolean) && chosen.slice().sort().join() === setNames.slice().sort().join();
      if (setKey === 'Inspire me') return same ? 'Inspire me' : 'Inspire me (edited)' + tail;
      return (same ? setKey : setKey + ' (edited)') + tail;
    }

    /* Every change re-renders the sets, list and tray. Keep keyboard and
       screen-reader focus on the same control across that re-render. */
    function update() {
      var a = document.activeElement, key = a && root.contains(a) ? a.getAttribute('data-key') : null;
      renderSets(); renderList(); renderTray();
      $('[data-ph-ss-tray]').hidden = !chosen.some(Boolean) && !setKey;
      if (key) { var back = root.querySelector('[data-key="' + key.replace(/"/g, '') + '"]'); if (back) back.focus(); }
    }

    $('[data-ph-ss-clear]').addEventListener('click', function () {
      chosen = [null, null, null]; setKey = null; setNames = null; surprised = {};
      update();
    });

    /* -------------------------------------------------------------- reveal */
    function reveal(idx) {
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var cards = $$('.ph-ss__pick');
      idx.forEach(function (i, order) {
        var card = cards[i];
        if (!card) return;
        card.classList.add('is-veiled');
        setTimeout(function () { if (card.isConnected) card.classList.remove('is-veiled'); }, REVEAL_FIRST + order * REVEAL_GAP);
      });
    }

    /* ------------------------------------------------------- add to basket */
    var add = $('[data-ph-ss-add]');
    add.addEventListener('click', function () {
      if (chosen.some(function (c) { return !c; })) return;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{
          id: cfg.variantId,
          quantity: 1,
          properties: { 'Sample 1': chosen[0], 'Sample 2': chosen[1], 'Sample 3': chosen[2], 'Set': label() }
        }] })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (data) {
          // An empty items list is the one-per-basket guard saying no
          // (assets/sample-service-limit.js has already shown its popup).
          if (data && data.items && data.items.length) { openBasket(); return; }
          // Empty items = the one-per-basket guard refused a second Sample
          // Service and showed its popup. Re-enable, and show the basket that
          // already holds one, so the click never looks like it did nothing.
          add.disabled = false;
          if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          $('[data-ph-ss-add-l1]').textContent = 'something went wrong, try again';
          add.disabled = false;
        });
    });

    /* Show the basket in the theme's own drawer, not the /cart page. The drawer
       listens for theme:cart:refresh, re-renders from the server (so the three
       samples show as the line's properties) and then opens itself via
       theme:product:added. A theme without the drawer still gets /cart. */
    function openBasket() {
      add.disabled = false;
      if (!document.querySelector('cart-drawer')) { window.location.href = '/cart'; return; }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    }

    function randomNames(count, exclude) {
      var pool = lib.map(nameOf).filter(function (n) { return exclude.indexOf(n) === -1; }), out = [];
      while (out.length < count && pool.length) out.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]);
      return out;
    }

    renderChips();
    update();
    window.addEventListener('resize', fitNames);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNames);
  }

  /* One entry per fragrance. Rows arrive in best-selling order, so the first
     row seen for a fragrance fixes its rank. */
  function fold(rows) {
    var map = {}, order = [];
    rows.forEach(function (r) {
      var x = map[r.n];
      if (!x) {
        x = map[r.n] = { name: r.n, fam: '', blurb: '', notes: '', img: '', imgRank: 9, first: Infinity, isNew: false, available: false, copyRank: 9 };
        order.push(x);
      }
      if (!x.fam && r.f) x.fam = r.f;
      if (r.p && r.p < x.first) x.first = r.p;
      if (r.new) x.isNew = true;
      if (r.a) x.available = true;
      var copyRank = r.s === '50' ? 0 : r.s === '100' ? 1 : r.s === 'other' ? 2 : 9;
      if (copyRank < x.copyRank && (r.b || r.o)) { x.copyRank = copyRank; x.blurb = r.b || ''; x.notes = r.o || ''; }
      // Image: the 50ml packshot, then 100ml, other, handblown last (Thom, 2 Oct 2026).
      var imgRank = r.s === '50' ? 0 : r.s === '100' ? 1 : r.s === 'other' ? 2 : 3;
      if (r.i && imgRank < x.imgRank) { x.imgRank = imgRank; x.img = r.i; }
    });
    // Out of stock in every size: not offered, and the sets refill without it.
    return order.filter(function (x) { return x.available; });
  }

  /* Klaviyo Client API: subscribe to the list, then record the event. Both
     are fire-and-forget; the library opens whatever Klaviyo says. */
  function klaviyoStart(k, email) {
    var base = 'https://a.klaviyo.com/client/', q = '?company_id=' + encodeURIComponent(k.company);
    var headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
    fetch(base + 'subscriptions/' + q, {
      method: 'POST', headers: headers,
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Sample Service gate',
        profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      }, relationships: { list: { data: { type: 'list', id: k.list } } } } })
    }).catch(function () {});
    fetch(base + 'events/' + q, {
      method: 'POST', headers: headers,
      body: JSON.stringify({ data: { type: 'event', attributes: {
        properties: { page: location.pathname },
        metric: { data: { type: 'metric', attributes: { name: 'Start the Sample Service' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      } } })
    }).catch(function () {});
  }

  function remember(v) { try { localStorage.setItem(STORE_KEY, v); } catch (e) {} }
  function recall() {
    try {
      localStorage.removeItem('phss_email'); // an earlier build kept the email itself; clear it
      return localStorage.getItem(STORE_KEY);
    } catch (e) { return null; }
  }
  /* Packshot framing (Thom, 29 Sep 2026). The packshots are all square, but
     the bottle fills a different share of each. Measured 29 Sep on the images
     the tray showed then (handblown where there was one; the 50ml since 2 Oct 2026): most handblown 195-201 of
     240px, Clay's new packshot 176, Soap (50ml image, no handblown) 180. In
     the tray that read as the card shrinking when the reel landed on Clay. Each image is measured once (bottle height
     against the frame, from the pixels) and scaled so every bottle stands the
     same height in its box: scaled, never stretched. Measured once per URL and
     cached; if the canvas can't be read, the image shows unscaled. */
  var FRAME_FILL = 198 / 240, fills = {};
  function frame(im, src) {
    im.src = src;
    if (fills[src] != null) { apply(); return; }
    im.style.setProperty('--ph-ss-fit', 1);
    im.addEventListener('load', function once() {
      im.removeEventListener('load', once);
      if (im.getAttribute('src') !== src) return; // the reel has moved on: never measure the wrong image
      if (fills[src] == null) fills[src] = measure(im);
      apply();
    });
    function apply() {
      var f = fills[src], k = f ? FRAME_FILL / f : 1;
      im.style.setProperty('--ph-ss-fit', Math.min(1.25, Math.max(0.85, k)).toFixed(3));
    }
  }
  function measure(im) {
    try {
      var w = im.naturalWidth, h = im.naturalHeight;
      if (!w || !h) return 0;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(im, 0, 0);
      var d = g.getImageData(0, 0, w, h).data, r = d[0], gr = d[1], b = d[2], top = -1, bot = -1;
      for (var y = 0; y < h && top < 0; y++) for (var x = 0; x < w; x++) { var i = (y * w + x) * 4; if (Math.abs(d[i] - r) + Math.abs(d[i + 1] - gr) + Math.abs(d[i + 2] - b) > 30) { top = y; break; } }
      for (var y2 = h - 1; y2 > top && bot < 0; y2--) for (var x2 = 0; x2 < w; x2++) { var j = (y2 * w + x2) * 4; if (Math.abs(d[j] - r) + Math.abs(d[j + 1] - gr) + Math.abs(d[j + 2] - b) > 30) { bot = y2; break; } }
      return top < 0 ? 0 : (bot - top + 1) / h;
    } catch (e) { return 0; }
  }

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function nameOf(x) { return x.name; }
  function unique(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function az(a, b) { return String(a).localeCompare(String(b), 'en-GB'); }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ph-ss]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
